import posthog from 'posthog-js';

// ✅ Get or Generate Anonymous ID
export const getAnonymousId = () => {
    let anonId = localStorage.getItem('anonId');
    if (!anonId) {
        anonId = `anon_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
        localStorage.setItem('anonId', anonId);
    }
    return anonId;
};

// ✅ Check if Analytics is Allowed
export const isAnalyticsEnabled = () => {
    // Simple check for local environment or localhost hostname
    if (import.meta.env.VITE_APP_ENV === 'local'|| window.location.hostname === 'localhost') return false; //  Prevent tracking in local env
    
    const cookiePreferences = JSON.parse(localStorage.getItem('cookiePreferences') || '{}');
    return localStorage.getItem('cookieConsent') === 'true' && cookiePreferences.analytics === true;
};

// ✅ Initialize PostHog if Analytics is Enabled
export const initPostHog = () => {
    if (!isAnalyticsEnabled()) return;

    posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
        api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://eu.posthog.com',
        autocapture: false, // 🔹 Disable automatic tracking
        disable_session_recording: false, // Optional: Can be turned on/off
        persistence: 'cookie',
        debug: import.meta.env.VITE_APP_ENV !== 'production',
        cookie_domain: import.meta.env.VITE_APP_ENV === 'production' ? '.balan.ai' : null,
        distinct_id: getAnonymousId(),
        // Add property to filter out localhost in case events still get through
        loaded: (posthog) => {
            posthog.register({
                environment: import.meta.env.VITE_APP_ENV,
                is_production: import.meta.env.VITE_APP_ENV === 'production'
            });
        }
    });

    // ✅ Track Initial Page View
    trackPageView();
};

// ✅ Track Page Views (called on navigation)
export const trackPageView = () => {
    if (!isAnalyticsEnabled()) return;

    posthog.capture('$pageview', {
        page: window.location.pathname,
        url: window.location.href,
        referrer: document.referrer || 'direct',
        environment: import.meta.env.VITE_APP_ENV, // Add environment property to each event
        hostname: window.location.hostname    // Add hostname to help with filtering
    });
};

// ✅ Identify User After Login/Register
export const identifyUser = (user) => {
    if (!user || !isAnalyticsEnabled()) return;

    const storedUserId = localStorage.getItem('anonId');

    // ✅ Check if user has changed (i.e., a new login/register)
    if (storedUserId !== user.id) {
        posthog.identify(user.id, {
            email: user.email,
            name: user.name,
            environment: import.meta.env.VITE_APP_ENV
        });

        // ✅ Store new user ID in localStorage to track changes
        localStorage.setItem('anonId', user.id);
    }
};